import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputFieldComponent } from '@shared/components/form/input/input-field.component';
import { LabelComponent } from '@shared/components/form/label/label.component';
import { ButtonComponent } from '@shared/components/ui/button/button.component';
import { DeleteTrigger } from '@shared/components/ui/delete-trigger/delete-trigger';
import { GrillaNavDirective, PegadoColumna } from '@shared/components/ui/grilla/grilla-nav.directive';
import { FilaSalidaFresca } from './salidas-frescas.model';

@Component({
  selector: 'app-salidas-frescas',
  imports: [ButtonComponent, DeleteTrigger, GrillaNavDirective, InputFieldComponent, LabelComponent, ReactiveFormsModule],
  templateUrl: './salidas-frescas.html',
  styleUrl: '../planilla-lote/planilla-lote.css',
})
export class SalidasFrescas {
  @Input() filas: FilaSalidaFresca[] = [];
  @Input() puedeCrear = false;
  @Input() puedeEliminar = false;
  @Input() guardando = false;
  @Output() agregar = new EventEmitter<void>();
  @Output() eliminar = new EventEmitter<FilaSalidaFresca>();

  /** Pega una o varias filas del Excel sin crear envíos implícitos ni alterar los guardados. */
  pegar({ columna, fila, valores }: PegadoColumna): void {
    valores.forEach((valor, offset) => {
      const actual = this.filas[fila + offset];
      if (!actual?.form.enabled) return;
      actual.error = '';
      if (columna === 'nro_embriones') {
        if (!valor.trim()) {
          actual.form.controls.nro_embriones.setValue('');
          actual.form.controls.nro_embriones.markAsDirty();
          return;
        }
        const cantidad = Number(valor);
        if (!Number.isInteger(cantidad) || cantidad < 1) {
          actual.error = 'La cantidad debe ser un entero mayor que cero.';
          return;
        }
        actual.form.controls.nro_embriones.setValue(cantidad);
        actual.form.controls.nro_embriones.markAsDirty();
      } else if (columna === 'fecha_salida') {
        if (!valor.trim()) {
          actual.form.controls.fecha_salida.setValue('');
          actual.form.controls.fecha_salida.markAsDirty();
          return;
        }
        const fecha = this.fechaIso(valor);
        if (!fecha) {
          actual.error = 'La fecha debe tener formato dd/mm/aaaa.';
          return;
        }
        actual.form.controls.fecha_salida.setValue(fecha);
        actual.form.controls.fecha_salida.markAsDirty();
      }
    });
  }

  private fechaIso(valor: string): string | null {
    const texto = valor.trim();
    const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(texto);
    const partes = iso ? [iso[3], iso[2], iso[1]] : /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(texto)?.slice(1);
    if (!partes) return null;
    const [dia, mes, anio] = partes.map(Number);
    const fecha = new Date(anio, mes - 1, dia);
    return fecha.getFullYear() === anio && fecha.getMonth() === mes - 1 && fecha.getDate() === dia
      ? `${anio}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}` : null;
  }
}
